<template>
  <div>
    <van-nav-bar
      :title="$t('app.announcement.title')"
      :left-text="$t('app.common.back')"
      left-arrow
      @click-left="$router.push('/member/members')"
    />
    <div style="padding: 0px 10px; margin-top: 10px">
      <van-loading
        v-if="isLoading"
        style="text-align: center; padding-top: 20px"
        >{{$t('app.common.loading')}}</van-loading
      >
      <div
        v-for="(item, index) in announceList"
        :key="index"
        style="border-bottom: 1px solid #dcdee0"
      >
        <div v-on:click="showAboutUsContent(item)">
          <p v-html="item.name" class="title">
            {{ item.name }}
          </p>
          <p style="margin: 2px 0px; color: #969799; font-size: 13px">
            {{ $getDeviceTime(item.time) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Announcement",
  data() {
    return {
      announceList: [],
      isLoading: false,
    };
  },
  methods: {
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    getList() {
      let that = this;
      that.isLoading = true;
      that
        .$http({
          url: "/",
          method: "POST",
          data: {
            nozzle: "notice",
            token: sessionStorage.getItem("token"),
          },
        })
        .then((ret) => {
          that.isLoading = false;
          let resData = ret.data;
          if (resData.code === 1) {
            that.announceList = resData.data;
          } else {
            that.$toast.fail(that.$t(resData.msg));
          }
        })  
        .catch(()=>{
          that.isLoading = false; 
        });
    },
    showAboutUsContent(item) {
      this.$store.state.announcement_title = item.name;
      this.$store.state.announcement_content = item.content;
      this.$router.push({
        path: "/member/announcement_detailed",
      });
    },
  },
  mounted: function () {
    let that = this;
    this.isLogin();
    this.getList();
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

.title {
  margin: 2px 0px;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/components/Announcement.vue